var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GreenTick"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 156",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4BB543"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.59025 13.462C8.49282 13.462 8.39282 13.4235 8.31847 13.3491L5.49806 10.5287C5.34678 10.3775 5.34678 10.1339 5.49806 9.98517C5.64934 9.83645 5.89292 9.83389 6.04163 9.98517L8.59025 12.5338L13.9593 7.16476C14.1106 7.01348 14.3541 7.01348 14.5029 7.16476C14.6516 7.31604 14.6541 7.55962 14.5029 7.70833L8.86204 13.3491C8.78768 13.4235 8.68768 13.462 8.59025 13.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59027 13.8466C8.39433 13.8466 8.19544 13.77 8.04652 13.6211L5.22611 10.8007C4.92593 10.5005 4.92256 10.0116 5.22844 9.71089C5.52462 9.41973 6.01089 9.40675 6.31457 9.71417L8.59027 11.9899L13.6873 6.8928C13.9875 6.59261 14.4764 6.58924 14.7771 6.89513C15.0683 7.19131 15.0813 7.67758 14.7739 7.98127L9.13401 13.6211C8.98509 13.77 8.7862 13.8466 8.59027 13.8466ZM14.5029 7.70833C14.6541 7.55962 14.6516 7.31604 14.5029 7.16476C14.3541 7.01348 14.1106 7.01348 13.9593 7.16476L8.59025 12.5338L6.04163 9.98517C5.89292 9.83389 5.64934 9.83645 5.49806 9.98517C5.34678 10.1339 5.34678 10.3775 5.49806 10.5287L8.31847 13.3491C8.39282 13.4235 8.49282 13.462 8.59025 13.462C8.68768 13.462 8.78768 13.4235 8.86204 13.3491L14.5029 7.70833Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.3ed65d0b2910b06dee246a1c83964eb4.svg";
export { ForwardRef as ReactComponent };